import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Text, Icon } from 'components/common/Elements/Elements';
import { useRegionalLink } from 'hooks/useRegionalLink';

import classes from './LinkBack.module.scss';

const LinkBack = ({ text }) => {
  const { url } = useRouteMatch();
  const generateRegionalPath = useRegionalLink();

  let newUrl = url.split('/');
  newUrl.pop();
  newUrl = newUrl.join('/');

  return (
    <NavLink to={generateRegionalPath(newUrl)} className={classes.link}>
      <Icon icon="reply" size="16px" className={classes.icon} />
      <Text weight="m" className={classes.text}>
        Back to {text}
      </Text>
    </NavLink>
  );
};

LinkBack.propTypes = {
  text: PropTypes.string
};

export default LinkBack;
